import {Modal} from "bootstrap";

const notifications = document.querySelectorAll("[data-notification]");
let dismissed = localStorage.getItem('uonotification_dismissed');
dismissed = dismissed ? JSON.parse(dismissed) : [];

function saveDismissed() {
    localStorage.setItem('uonotification_dismissed', JSON.stringify(dismissed));
}

notifications.forEach(notification => {
    const id = parseInt(notification.dataset.notification);
    if (id && dismissed.indexOf(id) === -1) {
        const modal = new Modal(notification);
        modal.show();
        notification.addEventListener('hide.bs.modal', () => {
            dismissed.push(id);
            saveDismissed();
        })
    }
})